
import { TextSectionTypeInfoBase } from './text-section.typeinfo.base';


export class TextSectionTypeInfo extends TextSectionTypeInfoBase {
}

export const TEXT_SECTION_TYPE: TextSectionTypeInfo = new TextSectionTypeInfo();



